export default {
    data() {
        return {
            name: '',
            email: '',
            message: '',
            sendingMail: false,
            invalidInputs: false,
        };
    },
    created() {
        window.scrollTo(0, 0);
    },
    methods: {
        submitEmail() {
            if (this.name && this.email && this.message) {
                this.invalidInputs = false;
                this.sendingMail = true;
                const messageBody = `Name: ${
                    this.name
                }\n`
                    + `Email: ${
                        this.email
                    }\n`
                    + `Message: ${
                        this.message
                    }\n`;
                window.location.href = `mailto:guyanalive592@gmail.com?subject=New%20Message%20from%20Website&body=${
                    encodeURI(messageBody)}`;
                setTimeout(() => {
                    this.sendingMail = false;
                    this.name = '';
                    this.email = '';
                    this.message = '';
                }, 3000);
            } else {
                this.invalidInputs = true;
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/contact/contact.page.js